import {
    GET_EVENT_PAGE_DATA,
    CLEAR_EVENT_PAGE_DATA,
    SET_EVENT_PAGE_EVENT_TYPE
} from "../actiontypes";

const INITIAL_STATE = {
    data: {},
    eventType: ""
};

/* EventPageReducer =>
    GET_EVENT_PAGE_DATA - Adds All Event Page Data
    CLEAR_EVENT_PAGE_DATA - Clears All Event Page Data
*/
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_EVENT_PAGE_DATA:
            return { ...state, data: { ...action.payload } };
        case CLEAR_EVENT_PAGE_DATA:
            return { ...state, ...INITIAL_STATE };
        case SET_EVENT_PAGE_EVENT_TYPE:
            return { ...state, eventType: action.payload };
        default:
            return state;
    }
};
